import { alpha, Theme } from '@mui/material/styles';
import { DrawerProps } from '@mui/material';
import { glassSurface } from '../glass';

// ----------------------------------------------------------------------

export default function Drawer(theme: Theme) {
  const isLight = theme.palette.mode === 'light';

  return {
    MuiDrawer: {
      styleOverrides: {
        paper: {
          ...glassSurface(theme, 'strong'),
          border: 'none',
          borderRight: `1px solid ${alpha(theme.palette.common.white, isLight ? 0.55 : 0.08)}`,
          boxShadow: isLight ? theme.customShadows.z12 : theme.customShadows.z16,
        },
        root: ({ ownerState }: { ownerState: DrawerProps }) => ({
          ...(ownerState.variant === 'temporary' && {
            '& .MuiDrawer-paper': {
              boxShadow: `-40px 40px 80px -8px ${alpha(
                isLight ? theme.palette.grey[500] : theme.palette.common.black,
                0.24
              )}`,
            },
          }),
        }),
      },
    },
  };
}
